Controller.$inject = ['$element'];

function Controller($element) {
    let self = this;

    self.$postLink = () => {
        if (self.expanded) {
            const accordionPanelElements = $element[0].querySelectorAll('.hui-accordion-panel');
            const accordionHeaderElements = $element[0].querySelectorAll('.hui-accordion-header');
            accordionPanelElements.forEach((element) => {
                element.classList.add('open');
            });

            accordionHeaderElements.forEach((element) => {
                element.classList.add('panel-open');
            });
        }
    }
}

export function HuiAccordion() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            color: '@',
            iconPosition: '@',
            expanded: '<'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
                <div class="hui hui-accordion"
                    ng-class="[
                        'hui-' + ($huiCtrl.color || 'accent'),
                         $huiCtrl.iconPosition === 'end'? 'with-icon-end' : '']"
                   ng-transclude></div>
            `;
        }
    }
}